import React, { Component } from "react";
import { findIndex } from "lodash";
import { Button, Modal } from "react-bootstrap";
import {
  TEXT_SAVE,
  TEXT_NO,
  MAX_WIDTH_SP,
  RING_SIZE_DEFAULT,
  RING_COLOR_DEFAULT
} from "../../const";
import DesignTool from "../../designtool";

export default class DialogConfirmKeepDesign extends Component {
  handleResetDesignTool() {
    let {
      ringIdClick,
      handleUpdateState,
      getWidthBrowser,
      ringTypeList
    } = this.props;

    handleUpdateState("isShowDialogConfirmKeepDesign", false);
    handleUpdateState("isShowModalMaterial", true);
    handleUpdateState("idMaterialActive", 1);
    handleUpdateState("ringIdActive", ringIdClick);
    handleUpdateState("isResetDesign", true);

    //- Show tab on SP version
    if (MAX_WIDTH_SP > getWidthBrowser()) {
      handleUpdateState("isShowModalRingList", true);
      handleUpdateState("isShowPopupSp", true);
      handleUpdateState("isShowModalCategoryList", false);
      handleUpdateState("isShowModalFortuneList", false);
      handleUpdateState("isShowModalColorList", false);
    }

    //- Reset design tool
    DesignTool.clearItems();

    let indexItem = findIndex(ringTypeList, item => item.id === ringIdClick);

    //- Set default ring select
    if (indexItem !== -1) {
      let valueMaxMin=DesignTool.getMinMaxSizeFromListItem(ringTypeList[indexItem],ringIdClick);
      let itemRing = ringTypeList[indexItem].rings[0];
      handleUpdateState("designInfo", {
        ringId: itemRing.id,
        ringSize: itemRing.sizes[0].size,
        ringSizeMin: valueMaxMin.ringSizeMin,
        ringSizeMax: valueMaxMin.ringSizeMax,
        ringColor: itemRing.colors[0].color_name,
        ringPrice: itemRing.price,
        ringColorCode: itemRing.colors[0].color_code
      });

      DesignTool.changeView(ringIdClick, {
        size: itemRing.sizes[0].size,
        sizeMin:valueMaxMin.ringSizeMin,
        sizeMax:valueMaxMin.ringSizeMax,
        color: itemRing.colors[0].color_code
      });

      return;
    }

    handleUpdateState("designInfo", {
      ringId: 0,
      ringSize: null,
      ringColor: "",
      ringPrice: 0,
      ringColorCode: RING_COLOR_DEFAULT
    });

    DesignTool.changeView(ringIdClick, {
      size: RING_SIZE_DEFAULT,
      color: RING_COLOR_DEFAULT
    });
  }

  handleSaveDesign() {
    let {
      handleUpdateState,
      ringIdClick,
      designInfo,
      ringIdActive,
      getWidthBrowser
    } = this.props;
    let tmpDesignInfo = { ...designInfo };
    let items = [];
    DesignTool.getItems().map(item => {
      items = [...items, Object.assign({}, item)];
    });

    handleUpdateState("tmpRingIdActive", ringIdActive);
    handleUpdateState("isShowDialogConfirmKeepDesign", false);
    handleUpdateState("isShowModalMaterial", true);
    handleUpdateState("idMaterialActive", 1);
    handleUpdateState("ringIdActive", ringIdClick);
    handleUpdateState("isShowModalRingList", true);
    handleUpdateState("tmpListItem", items);
    handleUpdateState("tmpDesignInfo", tmpDesignInfo);

    // show tab on SP version
    if (MAX_WIDTH_SP > getWidthBrowser()) {
      handleUpdateState("isShowPopupSp", true);
      handleUpdateState("isShowModalCategoryList", false);
      handleUpdateState("isShowModalFortuneList", false);
      handleUpdateState("isShowModalColorList", false);
    }
  }

  render() {
    let { isShowDialogConfirmKeepDesign, handleUpdateState } = this.props;

    return (
      <Modal
        show={isShowDialogConfirmKeepDesign}
        onHide={() => handleUpdateState("isShowDialogConfirmKeepDesign", false)}
        aria-labelledby="contained-modal-title-vcenter"
        dialogClassName="dialog_custom modal_custom modal_custom_continue"
        centered
      >
        <Modal.Body>
          <button
            className="modal_close"
            onClick={() =>
              handleUpdateState("isShowDialogConfirmKeepDesign", false)
            }
          >
            <img src="/img/icon_close_new.png" alt="" />
          </button>
          <span>このデザインを使用し続けますか？</span>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={() => this.handleResetDesignTool()}>
            {TEXT_NO}
          </Button>
          <Button variant="primary" onClick={() => this.handleSaveDesign()}>
            {TEXT_SAVE}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}
